export const badgeLabelsComponent = {
  key: 'badgeLabelsComponent',
  name: 'Badge Labels Component',
  siteIdentifier: 'global',

  saveWithAutoshipLabel: 'Save {discount}% with Autoship',
};
